module.exports = __webpack_public_path__ + "static/media/album.78731bbd.svg";